import React from 'react'

import CheckoutOnboarding from './CheckoutOnboarding'

const CheckoutOnboardingContainer = () => {
  return <CheckoutOnboarding />
}

export default CheckoutOnboardingContainer
